import { render, staticRenderFns } from "./AddSecondaryStorage.vue?vue&type=template&id=d442cfcc&scoped=true&"
import script from "./AddSecondaryStorage.vue?vue&type=script&lang=js&"
export * from "./AddSecondaryStorage.vue?vue&type=script&lang=js&"
import style0 from "./AddSecondaryStorage.vue?vue&type=style&index=0&id=d442cfcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d442cfcc",
  null
  
)

export default component.exports